/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceMembersInviteRequest
 */
export interface WorkspaceMembersInviteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkspaceMembersInviteRequest
     */
    emails: Array<string>;
}

export function WorkspaceMembersInviteRequestFromJSON(json: any): WorkspaceMembersInviteRequest {
    return WorkspaceMembersInviteRequestFromJSONTyped(json, false);
}

export function WorkspaceMembersInviteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMembersInviteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emails': json['emails'],
    };
}

export function WorkspaceMembersInviteRequestToJSON(value?: WorkspaceMembersInviteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emails': value.emails,
    };
}

